export class UstawieniaSystemu {
    serwerPocztowy: string;
    port?: number;
    adresEmail: string;
}